import { render, staticRenderFns } from "./UStIDForm.vue?vue&type=template&id=492263ae&scoped=true"
import script from "./UStIDForm.vue?vue&type=script&lang=js"
export * from "./UStIDForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492263ae",
  null
  
)

export default component.exports